import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Eligibleapplication from "../Dashboard/Eligibleapplications";
import Pendingapplication from "../Dashboard/Pendingapplication";
import Vacancytable from "../Dashboard/Vacancytable";
import { useEffect, useState } from "react";
import {
  FetchDashboardConsent,
  getTodayAgendaDetails,
} from "helpers/backend_helper";
import { Col, Form, Row } from "reactstrap";
import { toast } from "react-toastify";
import PieChartConsent from "./PieChartConsent";
import CookieTypeTable from "./CookieTypeTable";
import DeletionRequestLineChart from "./DeletionRequestLineChart";
import DashboardDateTime from "../Dashboard/DashboardDateTime";
import cross from "../../assets/images/icon/cross.svg";
import arrow from "../../assets/images/icon/arrow.svg";
import calender_icon from "../../assets/images/icon/calender.svg";
import { useMsal } from "@azure/msal-react";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";

const Card = ({ imageSrc, title, value, units, link }) => (
  <div className="tabBox-wrapper">
    <Link to={link}>
      <div className="tab-details">
        <div className="d-flex align-items-center">
          <div className="tab-value">{value}</div>
          <div className="tab-ico ms-auto">
            <img src={imageSrc} alt={title} />
          </div>
        </div>
        <h2 className="tab-title">{title}</h2>
        {/*<div className="valueCounter d-flex align-items-center">
              <div className="candidate-value">
                <span>{units}</span>
              </div>
            </div>*/}
      </div>
    </Link>
  </div>
);

const CookieConsentDashboard = () => {
  const { t } = useTranslation();
  const [dashboardData, setDashboardData] = useState("");
  const [agendaDetails, setAgendaDetails] = useState("");
  const [tabType, setTabType] = useState("current");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    getAgendaData();
  }, []);

  useEffect(() => {
    setDashboardData("");
    if (tabType !== "custom") {
      getDashboardData(tabType);
    }
  }, [tabType]);

  const getAgendaData = async () => {
    await getTodayAgendaDetails()
      .then(res => {
        let responseData = decryptDataFromArray(res);

        setAgendaDetails(responseData?.data);
      })
      .catch(err => {});
  };

  const getDashboardData = async type => {
    let payload = `?type=${type}&startDate=${startDate}&endDate=${endDate}`;
    await FetchDashboardConsent(payload)
      .then(res => {
        let responseData = decryptDataFromArray(res);

        if (responseData?.status) {
          setDashboardData(responseData?.data);
        } else {
          //   setError("No data available");
        }
      })
      .catch(err => {
        toast.error(err?.response?.data?.message || "Something Went Wrong.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        // setError("No data Available");
      });
  };

  //hide-showw-in mobile-view
  const [showDetails, setShowDetails] = useState(false);

  const handleButtonClick = () => {
    setShowDetails(!showDetails); // Toggle the state when button is clicked
  };

  const handleCloseClick = () => {
    setShowDetails(false); // Close the details when cross button is clicked
  };

  //date
  const [inputTypeStart, setInputTypeStart] = useState("text");
  const [inputTypeEnd, setInputTypeEnd] = useState("text");

  const { instance, accounts } = useMsal();

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  return (
    <div className="dashboard-main-container">
      <div className="inner-wrapper cookies-conteste">
        <div className="tabbing-wrapper d-flex justify-content-between mt-2 mb-2 border-0">
          <div className="tab-head d-flex align-items-lg-center justify-content-lg-between">
            {/*<ul className="tab-btn-wrapper d-flex align-items-center">
              <li>
                <Link
                  onClick={() => setTabType("current")}
                  to={"/cookie-consent-dashboard"}
                  className={`tab-link ${
                    tabType === "current" ? "active" : ""
                  }`}
                  id="current-month"
                >
                  Current Month
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => setTabType("previous")}
                  to={"/cookie-consent-dashboard"}
                  className={`tab-link ${
                    tabType === "previous" ? "active" : ""
                  }`}
                  id="last-month"
                >
                  Last 3 Months
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => setTabType("custom")}
                  to={"/cookie-consent-dashboard"}
                  className={`tab-link ${tabType === "custom" ? "active" : ""}`}
                  id="custom"
                >
                  Custom
                </Link>
              </li>
                </ul> */}
          </div>
        </div>

        {tabType === "custom" && (
          <div className="filter-wrapper gap-3 d-flex align-items-center mb-4">
            <div controlId="formDate" className="input-formtext d-flex">
              {/* <span>Start Date :</span> */}
              <input
                placeholder="Start Date"
                className="form-control"
                type={inputTypeStart}
                onChange={e => setStartDate(e.target.value)}
                onFocus={() => setInputTypeStart("date")}
                onBlur={() => setInputTypeStart("text")}
                id="date"
                value={startDate}
              />
              {/* <span className="calender-icon form">
                <img src={calender_icon} alt="" />
              </span> */}
            </div>

            <div controlId="formDate" className="input-formtext d-flex">
              {/* <span>End Date :</span> */}
              <input
                placeholder="End Date"
                className="form-control"
                type={inputTypeEnd}
                onChange={e => setEndDate(e.target.value)}
                onFocus={() => setInputTypeEnd("date")}
                onBlur={() => setInputTypeEnd("text")}
                id="date"
                value={endDate}
              />
              {/* <span className="calender-icon form">
                <img src={calender_icon} alt="" />
              </span> */}
            </div>

            {/* <div>
                <div
                  controlId="formDate"
                  className="input-formtext d-flex"
                  style={{ width: "200px" }}
                >
                  <span>Start Date :</span>
                  <input
                    type="date"
                    class="form-control"
                    id="date"
                    onChange={e => setStartDate(e.target.value)}
                    placeholder="Start Date"
                    value={startDate}
                  />
                </div>
              </div>

              <div>
                <div
                  controlId="formDate"
                  className="input-formtext d-flex"
                  style={{ width: "200px" }}
                >
                  <span>End Date :</span>
                  <input
                    type="date"
                    class="form-control"
                    id="date"
                    onChange={e => setEndDate(e.target.value)}
                    value={endDate}
                  />
                </div>
              </div> */}

            <button
              className="btn btn-primary search"
              onClick={() => getDashboardData("custom")}
            >
              {t(`Cookie Dashboard.Search`)}
            </button>
          </div>
        )}

        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            // aria-labelledby="pills-home-tab"
          >
            <div className="outerTab-box-wrapper cookies-con dashboard-card">
              <Row>
                <Col xl={6} lg={12}>
                  <div className="card-columns cookies-manager row">
                    <Col lg={12} md={12}>
                      <div class="tabBox-wrapper">
                        <Link to="/cookie-list">
                          <div class="tab-details">
                            <div class="d-flex align-items-center tabs-card-cokoe">
                              <div class="tab-value">
                                {dashboardData?.counts?.totalConsent || 0}
                              </div>
                              <div class="tab-ico ms-auto">
                                <img src="../img/all-constent.svg" alt="" />
                              </div>
                            </div>
                            <h2 class="tab-title">
                              {t(`Cookie Dashboard.All Consent`)}
                              <img
                                src={arrow}
                                alt="Chevron Icon"
                                class="right-chevron"
                              />
                            </h2>
                          </div>
                        </Link>
                      </div>
                    </Col>

                    <Col lg={12} md={12}>
                      {/* Total Cookie Consent */}
                      {/* <Card
                      imageSrc="../img/Cookie-Consent.svg"
                      title={
                        <>
                          Cookie Consent{" "}
                          {
                            <img
                              src={arrow}
                              alt="Chevron Icon"
                              className="right-chevron"
                            />
                          }
                        </>
                      }
                      value={dashboardData?.counts?.CookieConsent || 0}
                      link={"/cookie-list"}
                    /> */}

                      <div class="tabBox-wrapper  OnboardedApplicants">
                        <Link to="/cookie-list">
                          <div class="tab-details">
                            <div class="d-flex align-items-center tabs-card-cokoe">
                              <div class="tab-value">
                                {dashboardData?.counts?.CookieConsent || 0}
                              </div>
                              <div class="tab-ico ms-auto">
                                <img
                                  src="../img/cookies-constent2.svg"
                                  alt="Cookie Consent"
                                />
                              </div>
                            </div>
                            <h2 class="tab-title">
                              {t(`Cookie Dashboard.Cookie Consent`)}
                              <img
                                src={arrow}
                                alt="Chevron Icon"
                                class="right-chevron"
                              />
                            </h2>
                          </div>
                        </Link>
                      </div>
                    </Col>

                    <Col lg={12} md={12}>
                      {/* PII Consent List */}
                      {/* <Card
                      imageSrc="../img/PII-Consent.svg"
                      title={
                        <>
                          PII Consent{" "}
                          {
                            <img
                              src={arrow}
                              alt="Chevron Icon"
                              className="right-chevron"
                            />
                          }
                        </>
                      }
                      value={dashboardData?.counts?.PIIConsentUsers || 0}
                      link={"/consent-list"}
                    /> */}

                      <div class="tabBox-wrapper underassement">
                        <Link to="/consent-list">
                          <div class="tab-details">
                            <div class="d-flex align-items-center tabs-card-cokoe">
                              <div class="tab-value">
                                {dashboardData?.counts?.PIIConsentUsers || 0}
                              </div>
                              <div class="tab-ico ms-auto">
                                <img src="../img/pii-content3.svg" alt="" />
                              </div>
                            </div>
                            <h2 class="tab-title">
                              {t(`Cookie Dashboard.PII Consent`)}
                              <img
                                src={arrow}
                                alt="Chevron Icon"
                                class="right-chevron"
                              />
                            </h2>
                          </div>
                        </Link>
                      </div>
                    </Col>

                    <Col lg={12} md={12}>
                      {/* Account Deletion Request */}
                      {/* <Card
                      imageSrc="../img/Account-Deletion-Reguest.svg"
                      title={
                        <>
                          Account Deletion Request{" "}
                          {
                            <img
                              src={arrow}
                              alt="Chevron Icon"
                              className="right-chevron"
                            />
                          }
                        </>
                      }
                      value={dashboardData?.counts?.accountDeletionUsers || 0}
                      link={"/account-deletion-list"}
                    /> */}

                      <div class="tabBox-wrapper  RejectedApplicants">
                        <Link to="/account-deletion-list">
                          <div class="tab-details">
                            <div class="d-flex align-items-center tabs-card-cokoe">
                              <div class="tab-value">
                                {dashboardData?.counts?.accountDeletionUsers ||
                                  0}
                              </div>
                              <div class="tab-ico ms-auto">
                                <img
                                  src="../img/account-deletation.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                            <h2 class="tab-title">
                              {t(`Cookie Dashboard.Account Deletion Requests`)}
                              <img
                                src={arrow}
                                alt="Chevron Icon"
                                class="right-chevron"
                              />
                            </h2>
                          </div>
                        </Link>
                      </div>
                    </Col>

                    {/* Account Deletion Request
                    <Card
                      imageSrc="../img/Account-Deletion-Reguest.svg"
                      title={
                        <>
                          Account Deletion Request{" "}
                          {
                            <img
                              src={arrow}
                              alt="Chevron Icon"
                              className="right-chevron"
                            />
                          }
                        </>
                      }
                      value={dashboardData?.counts?.accountDeletionUsers || 0}
                      link={"/account-deletion-list"}
                    /> */}
                  </div>
                </Col>

                <Col xl={6} lg={12}>
                  <div className="total-graph-card">
                    <h3 className="d-flex align-items-center gap-2 heading-one pb-3">
                      {t(
                        `Cookie Dashboard.Total Cookie Consent By Browser Type`
                      )}
                    </h3>
                    <PieChartConsent data={dashboardData?.pieChartData || []} />
                    {/*<Vacancytable data={dashboardData?.vacancyTypeData || []} />*/}
                    {/*}<FunnelChart
                  data={dashboardData?.funnelData || ""}
                  pieChartData={dashboardData?.pieChartData || []}
                  acceptanceDetails={dashboardData?.acceptanceDetails || {}}
                /> */}
                  </div>
                </Col>
              </Row>

              {/* <div className="col-lg-12">
                <Eligibleapplication />
                <Pendingapplication data={dashboardData?.PendingList || []} />
              </div> */}

              {/* <div className="create-job-vacancy mt-5 d-md-flex align-items-center">
                <div className="job-vacancy-sec">
                  <div className="col-pic">
                    <img src="../img/creat-job-ico.svg" alt="" />
                  </div>
                  <h3 className="heading-three">Create a Job Vacancy</h3>
                  <p>
                    Embark on the journey of creating a job vacancy to welcome
                    talented individuals into your team.
                  </p>
                  <Link
                    href="javascript:void()"
                    className="btn btn-primary mt-3"
                  >
                    <svg
                      className="me-2"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 12h14m-7 7V5"
                      />
                    </svg>{" "}
                    Post New Job
                  </Link>
                </div>
                <div className="sec-pic">
                  <img src="../img/new-vacancy.svg" alt="" />
                </div>
              </div> */}
            </div>

            <div className="outerTab-box-wrapper cookies-dashboard">
              <div className="cookies-dashboard">
                <div className="col-lg-12 total-graph-card">
                  <h3 className="d-flex align-items-center gap-2 heading-one pb-4">
                    {t(`Cookie Dashboard.Monthly Cookie Consent By Category`)}
                  </h3>
                  <CookieTypeTable data={dashboardData?.cookieTypeData || []} />
                </div>
              </div>

              <div className="cookies-dashboard total-graph-card mt-4">
                <div className="col-lg-12">
                  <h3 className="d-flex align-items-center gap-2 heading-one pb-4">
                    {t(`Cookie Dashboard.Monthly Account Deletion Requests`)}
                  </h3>
                  <DeletionRequestLineChart
                    data={dashboardData?.deletionRequestData || []}
                  />
                </div>
              </div>

              {/* <div className="col-lg-12">
                <Eligibleapplication />
                <Pendingapplication data={dashboardData?.PendingList || []} />
              </div> */}

              {/* <div className="create-job-vacancy mt-5 d-md-flex align-items-center">
                <div className="job-vacancy-sec">
                  <div className="col-pic">
                    <img src="../img/creat-job-ico.svg" alt="" />
                  </div>
                  <h3 className="heading-three">Create a Job Vacancy</h3>
                  <p>
                    Embark on the journey of creating a job vacancy to welcome
                    talented individuals into your team.
                  </p>
                  <Link
                    href="javascript:void()"
                    className="btn btn-primary mt-3"
                  >
                    <svg
                      className="me-2"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 12h14m-7 7V5"
                      />
                    </svg>{" "}
                    Post New Job
                  </Link>
                </div>
                <div className="sec-pic">
                  <img src="../img/new-vacancy.svg" alt="" />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentDashboard;
